import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import ServiceDashboard from './ServiceDashboard';
import TechnicalServiceDashboard from './TechnicalServiceDashboardNew';
import SuperAdminDashboard from './SuperAdminDashboard';
import RequesterDashboard from './RequesterDashboard';
import { USER_ROLES, USER_ROLE_TRANSLATIONS } from '../models/School';
import { Box, Typography } from '@mui/material';

export default function Dashboard() {
  const { userRole } = useAuth();

  // Rediriger vers le bon dashboard selon le rôle
  switch (userRole) {
    case USER_ROLES.SUPER_ADMIN:
      return <SuperAdminDashboard />;
    case USER_ROLES.ADMIN:
      return <AdminDashboard />;
    case USER_ROLES.SERVICE:
      return <ServiceDashboard />;
    case USER_ROLES.REQUESTER:  
      return <RequesterDashboard />;
    case USER_ROLES.TECHNICAL:  
      return <TechnicalServiceDashboard />;
    default:
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <Typography variant="h5" color="error">
            Accès non autorisé
          </Typography>
          <Typography variant="body1">
            Votre rôle ({USER_ROLE_TRANSLATIONS[userRole] || userRole || 'non défini'}) ne permet pas d'accéder au tableau de bord.
            Veuillez contacter votre administrateur.
          </Typography>
        </Box>
      );
  }
}
